<div class="footer-widget-box list">
    <h4 class="footer-widget-title">Business Links</h4>
    <div class="footer-newsletter">
        <div class="subscribe-form">
            <ng-container *ngIf="isLoggedIn">
                <a class="theme-btn" [href]="gmsDashboardUrl" target="_blank" rel="noopener noreferrer">
                    Business Login <i class="fa-solid fa-right-to-bracket"></i>
                </a>
            </ng-container>
            <ng-container *ngIf="!isLoggedIn">
                <a class="theme-btn" [href]="erpBusinessLoginUrl" target="_blank" rel="noopener noreferrer">
                    Business Login <i class="fa-solid fa-right-to-bracket"></i>
                </a>
                <a class="theme-btn" [href]="erpBusinessRegisterUrl" target="_blank" rel="noopener noreferrer">
                    Register Business <i class="fa-solid fa-square-arrow-up-right"></i>
                </a>
            </ng-container>
        </div>
    </div>
</div>
